<template>
<div class='bto-sb-element'>
   <div class="bto-sb-event-odds-nav">
        <div class="bto-sb-event-odds-nav-labels bto-sb-collapse" :class="{'bto-sb-collapse-show': tabCollapsed}" @click="toggleCollapse()">
            <div class="bto-sb-event-odds-left">
                <span class="bto-sb-flag bto-sb-flag-oval" :class="items.categoryCss"></span>
                <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">{{items.categoryName}}</div>
            </div>
        </div>
    </div>
    <div class="bto-sb-antepost-content" v-show="!tabCollapsed">
        <div class="bto-sb-antepost-item"  v-for="(item,idx) in chunkArrayExact(items.categories,2)" :key="idx">
            <a v-for="(antepost,jdx) in item" :key="jdx" @click="$emit('openDetails',antepost.tournamentId, antepost.raceNumber)">
                <span class="bto-sb-antepost-time">{{antepost.apiDateTime}}</span>
                <span class="bto-sb-antepost-name">{{antepost.tournamentName}}</span>
            </a>
        </div>
    </div>
</div>
</template>
<script>
  import { chunkArrayExact } from '../../../services/utils';

  export default {
    name: 'AntepostRace',
    data() {
      return {
        tabCollapsed: false,
      };
    },
    props: {
      items: {
        type: Object,
        default: () => { },
      },
    },
    methods: {
      toggleCollapse() {
        this.tabCollapsed = !this.tabCollapsed;
      },
      chunkArrayExact,
    }
  };
</script>